/**
 * @generated SignedSource<<2b188462853e9ff5a7d5445483e96ea8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type subSectionIndexArticleList$data = {
  readonly id: string;
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"oneSectionTopWidgetQueue" | "topStoriesBlockQueueItemsEdge">;
    }>;
  } | null | undefined;
  readonly " $fragmentType": "subSectionIndexArticleList";
};
export type subSectionIndexArticleList$key = {
  readonly " $data"?: subSectionIndexArticleList$data;
  readonly " $fragmentSpreads": FragmentRefs<"subSectionIndexArticleList">;
};

import subSectionIndexArticleListPaginationQuery_graphql from './subSectionIndexArticleListPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "items"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 23,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": subSectionIndexArticleListPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "subSectionIndexArticleList",
  "selections": [
    {
      "alias": "items",
      "args": null,
      "concreteType": "QueueItemConnection",
      "kind": "LinkedField",
      "name": "__subSectionIndexArticleListQuery__items_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "withCarousel",
                  "value": true
                }
              ],
              "kind": "FragmentSpread",
              "name": "oneSectionTopWidgetQueue"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "topStoriesBlockQueueItemsEdge"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Queue",
  "abstractKey": null
};
})();

(node as any).hash = "3aba6dc4c388320d9ed55b64b87a0ea7";

export default node;
